import type { CSSProperties } from "react";

export const qnaActionStyle: CSSProperties = {
  padding: "7px 14px",
  borderRadius: 8,
  border: "1px solid #E5E5E5",
  background: "#fff",
  color: "#555",
  fontSize: 12.5,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6,
  whiteSpace: "nowrap",
  boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
  flex: "1 1 0",
  justifyContent: "center",
  fontFamily: "inherit",
};
